import {
    ADD_VENDORS_FAIL,
    ADD_VENDORS_SUCCESS,
    DELETE_VENDORS_FAIL,
    DELETE_VENDORS_SUCCESS,
    EXPORT_VENDORS_FAIL,
    EXPORT_VENDORS_SUCCESS,
    GET_VENDORS_DETAILS_FAIL,
    GET_VENDORS_DETAILS_SUCCESS,
    GET_VENDORS_LISTING_FAIL,
    GET_VENDORS_LISTING_SUCCESS,
    RESET_VENDORS_ATTACHMENT_STATE,
    RESET_VENDORS_STATE,
    UPDATE_VENDORS_FAIL,
    UPDATE_VENDORS_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    vendorsListing: [],
    vendorsDetails: [],
    addVendors: [],
    updateVendors: [],
    deleteVendors: [],
    exportVendors: [],
    error: [],
}

const Vendors = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_VENDORS_LISTING_SUCCESS:
            return {
                ...state,
                vendorsListing: action.payload
            }
        case GET_VENDORS_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_VENDORS_DETAILS_SUCCESS:
            return {
                ...state,
                vendorsDetails: action.payload
            }
        case GET_VENDORS_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_VENDORS_SUCCESS:
            return {
                ...state,
                addVendors: action.payload
            }
        case ADD_VENDORS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_VENDORS_SUCCESS:
            return {
                ...state,
                updateVendors: action.payload
            }
        case UPDATE_VENDORS_FAIL:
            return {
                ...state,
                error: action.payload,
                updateVendors: action.payload,
            }

        case DELETE_VENDORS_SUCCESS:
            return {
                ...state,
                deleteVendors: action.payload
            }
        case DELETE_VENDORS_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteVendors: action.payload
            }

        case EXPORT_VENDORS_SUCCESS:
            return {
                ...state,
                exportVendors: action.payload
            }
        case EXPORT_VENDORS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_VENDORS_ATTACHMENT_STATE:
            return {
                ...state,
                exportVendors: [],
                error: [],
            }
        case RESET_VENDORS_STATE:
            return {
                ...state,
                vendorsListing: [],
                vendorsDetails: [],
                addVendors: [],
                updateVendors: [],
                deleteVendors: [],
                exportVendors: [],
                error: [],
            }
        default:
            return state
    }
}

export default Vendors
